import React from 'react';
import styles from './AlertBanner.module.scss';

export default function AlertBanner({ children, theme = 'default' }) {
  const classNames = [styles.banner, styles[theme]].join(' ');
  return <div className={classNames}>{children}</div>;
}
